import Vue from 'vue'
import app from '@/main'

import emailCampaigns from './modules/email_campaigns'
import autocastsModule from './modules/autocasts'
import { adaptMessageCard } from '@/utils/index'

const emailsModule = {
  namespaced: true,
  modules: {
    emailCampaigns: emailCampaigns,
    autocasts: autocastsModule
  },

  getters: {
    loading: (state, getters, rootState, rootGetters) => (pageType) => {
      if (pageType === 'autocasts_report') {
        return rootState.reports.emails.autocasts.loading
      }

      if (pageType === 'emails_report') {
        return rootState.reports.emails.emailCampaigns.loading
      }
    },
    ordersSum: (state, getters, rootState, rootGetters) => (pageType) => {
      if (pageType === 'autocasts_report') {
        return rootState.reports.emails.autocasts.ordersSum
      }
      if (pageType === 'emails_report') {
        return rootState.reports.emails.emailCampaigns.ordersSum
      }
    },
    getAll: (state, getters, rootState, rootGetters) => (pageType, period) => {
      if (pageType === 'autocasts_report') {
        return rootGetters['reports/emails/autocasts/getAll'](period)
      }
      if (pageType === 'emails_report') {
        return rootGetters['reports/emails/emailCampaigns/getAll'](period)
      }
    },
    getPeriod: (state, getters, rootState, rootGetters) => (pageType) => {
      if (pageType === 'autocasts_report') {
        return rootState.reports.emails.autocasts.period
      }
      if (pageType === 'emails_report') {
        return rootState.reports.emails.emailCampaigns.period
      }
    },
    getData: (state, getters, rootState, rootGetters) => (pageType) => {
      if (pageType === 'autocasts_report') {
        return rootGetters['reports/emails/autocasts/getData']
      }
      if (pageType === 'emails_report') {
        return rootGetters['reports/emails/emailCampaigns/getData']
      }
    },
    pagination: (state, getters, rootState, rootGetters) => (pageType) => {
      if (pageType === 'autocasts_report') {
        return rootState.reports.emails.autocasts.pagination
      }
      if (pageType === 'emails_report') {
        return rootState.reports.emails.emailCampaigns.pagination
      }
    }
  },

  actions: {
    setPaginationPerPage: ({ commit }, { pageType, perPage }) => {
      const pagination = { page: 0, perPage: perPage }

      if (pageType === 'autocasts_report') {
        commit('reports/emails/autocasts/setPagination', pagination, {
          root: true
        })
      }

      if (pageType === 'emails_report') {
        commit('reports/emails/emailCampaigns/setPagination', pagination, {
          root: true
        })
      }
    },
    setPaginationPage: ({ commit, rootState }, { pageType, page }) => {
      if (pageType === 'autocasts_report') {
        const pagination = { ...rootState.reports.emails.autocasts.pagination, page }
        commit('reports/emails/autocasts/setPagination', pagination, {
          root: true
        })
      }

      if (pageType === 'emails_report') {
        const pagination = { ...rootState.reports.emails.emailCampaigns.pagination, page }
        commit('reports/emails/emailCampaigns/setPagination', pagination, {
          root: true
        })
      }
    },
    setPeriod: ({ commit }, { pageType, period }) => {
      if (pageType === 'autocasts_report') {
        commit('reports/emails/autocasts/setPeriod', period, {
          root: true
        })
      }

      if (pageType === 'emails_report') {
        commit('reports/emails/emailCampaigns/setPeriod', period, {
          root: true
        })
      }
    },

    GET_MESSAGES_IDS: async ({ commit, rootGetters }, { mailing_type }) => {
      let path

      if (mailing_type === 'autocasts') {
        path = 'reports/emails/autocasts'
      }

      if (mailing_type === 'email_campaigns') {
        path = 'reports/emails/emailCampaigns'
      }

      try {
        let response
        let payload

        if (mailing_type === 'email_campaigns') {
          response = await Vue.http.get(`${rootGetters.getBackendUrl}/messages/short`, {
            params: { channel: 'email' },
            headers: rootGetters.getAllResponseHeaders
          })
          payload = response.body.messages
        } else {
          response = await Vue.http.get(`${rootGetters.getBackendUrl}/autocasts/short`, {
            headers: rootGetters.getAllResponseHeaders
          })
          payload = response.body.autocasts
        }

        if (response.status === 200) {
          commit(`${path}/setAllMessages`, payload, { root: true })
        } else {
          app.$raven.captureException(new Error('Error - GET_MESSAGES_IDS, store/reports/emails'), {
            extra: response,
            tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_IDS' }
          })
        }
      } catch (e) {
        console.error(e)
        app.$raven.captureException(new Error('Error - GET_MESSAGES_IDS, store/reports/emails'), {
          extra: e,
          tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_IDS' }
        })
        throw new Error(e.statusText)
      }
    },

    GET_MESSAGES_INFO: async ({ commit, rootGetters, dispatch }, { mailing_type, period }) => {
      let path

      if (mailing_type === 'autocasts') {
        path = 'reports/emails/autocasts'
      }

      if (mailing_type === 'email_campaigns') {
        path = 'reports/emails/emailCampaigns'
      }

      commit(`${path}/setLoading`, true, { root: true })

      await dispatch('GET_MESSAGES_IDS', { mailing_type })

      const ids = rootGetters[`${path}/getAllIds`](period)

      if (!ids) {
        commit(`${path}/setOrdersSum`, 0, { root: true })
        commit(`${path}/setLoading`, false, { root: true })
        return
      }

      let data = { test_emails: false, message_ids: ids }
      if (period && period.start) {
        data.start = period.start
        data.end = period.end
      }

      try {
        const response = await Vue.http.post(`${rootGetters.getBackendUrl}/messages/email/stats`, data,{
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.status === 200) {
          
          commit(`${path}/setMessagesInfo`, (response.body.messages || []).map(adaptMessageCard), { root: true })

        } else {
          app.$raven.captureException(
            new Error('Error - GET_MESSAGES_INFO, store/reports/emails'),
            {
              extra: response,
              tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_INFO' }
            }
          )
        }

        commit(`${path}/setLoading`, false, { root: true })
      } catch (e) {
        commit(`${path}/setLoading`, false, { root: true })
        console.error(e)
        app.$raven.captureException(new Error('Error - GET_MESSAGES_INFO, store/reports/emails'), {
          extra: e,
          tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_INFO' }
        })
        throw new Error(e.statusText)
      }
    },
    GET_MESSAGES_ORDERS: async({ commit, rootGetters, getters, dispatch }, { mailing_type, period }) => {
      let path

      if (mailing_type === 'autocasts') {
        path = 'reports/emails/autocasts'
      }

      if (mailing_type === 'email_campaigns') {
        path = 'reports/emails/emailCampaigns'
      }

      commit(`${path}/setLoading`, true, { root: true })

      await dispatch('GET_MESSAGES_IDS', { mailing_type })

      const ids = rootGetters[`${path}/getAllIds`](period)

      if (!ids) {
        commit(`${path}/setOrdersSum`, 0, { root: true })
        commit(`${path}/setLoading`, false, { root: true })
        return
      }

      let data = { message_ids: ids, start: period.start, end: period.end }

      try {
        const response = await Vue.http.post(`${rootGetters.getBackendUrl}/messages/email/orders`, data,{
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.status === 200) {
          const { result_id, result_type } = response.body
          try{
            const task_result = await dispatch(
              'GET_TASK_RESULT',
              {
                result_id,
                result_type
              },
              {
                root: true
              }
            )
            if (task_result.body.ready === true) {

               const ordersSum = task_result.body.result.reduce((sum, message) => {
                  sum += message.orders_sum
      
                  return sum
                }, 0)

               commit(`${path}/setOrdersSum`, ordersSum, { root: true })
               commit(`${path}/updateMessagesInfo`, task_result.body.result, { root: true })
               

            }
          } catch(e) {
            throw e
          }

          commit(`${path}/setLoading`, false, { root: true })
         
        } else {
          app.$raven.captureException(
            new Error('Error - GET_MESSAGES_ORDERS, store/reports/emails'),
            {
              extra: response,
              tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_ORDERS' }
            }
          )
        }

        commit(`${path}/setLoading`, false, { root: true })
      } catch (e) {
        commit(`${path}/setLoading`, false, { root: true })
        console.error(e)
        app.$raven.captureException(new Error('Error - GET_MESSAGES_ORDERS, store/reports/emails'), {
          extra: e,
          tags: { component: 'store/reports/emails', method: 'GET_MESSAGES_ORDERS' }
        })
        throw new Error(e.statusText)
      }
    }
  }
}

export default emailsModule



// WEBPACK FOOTER //
// ./src/store/modules/reports/modules/emails/index.js